export default __webpack_public_path__ + "static/media/calendar.e661964b.svg";